<template lang="pug">
    .text-xs.text-blue-600.font-bold.cursor-pointer.underline(:title="BUTTONS_VALUES.get_sms_status" @click="onStatus({id})") {{id}}
</template>

<script>
//Config
import { BUTTONS_VALUES } from '@/configs/names';
//Store
import { SMSNameSpace, SMSActionTypes, SMSGetterTypes } from '@/store/sms/types';

export default {
    name: "GetSMSStatusComponent",
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    computed: {
        BUTTONS_VALUES() {
            return BUTTONS_VALUES
        },
        status() {
            return this.$store.getters[`${SMSNameSpace}/${SMSGetterTypes.GetStatus}`]
        },
    },
    methods: {
        async onStatus({id}) {
            await this.$store.dispatch(`${SMSNameSpace}/${SMSActionTypes.GetStatus}`, { params: {id} })
        },
    }
}
</script>